import DroppableFileInput from './DroppableFileInput';
import './DroppableFileInput.css';
import 'react-image-crop/dist/ReactCrop.css';

export default DroppableFileInput;



// WEBPACK FOOTER //
// ./src/shared/components/DroppableFileInput/index.js